export default "__VITE_ASSET__DNqroBzC__"